import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Field } from 'redux-form';
import _map from 'lodash/map';
import { FormGroupSelect } from 'components/Form';
import TrashTooltip from 'components/TrashTooltip';
import AutoCompleteMenuWrapper from 'components/AutoCompleteMenuWrapper';

import {
  entityType,
  connectedDictionaryType,
  fieldsType,
  dictionaryType,
} from 'types';

import './style.scss';

const PAGE = 1;
const SIZE = 50;

export class ConnectedDictionary extends Component {
  static propTypes = {
    allDictionaries: PropTypes.arrayOf(dictionaryType).isRequired,
    currentEntity: entityType.isRequired,
    fields: fieldsType,
    formValues: entityType,
    getAllDictionaries: PropTypes.func,
    index: PropTypes.number,
    isLoadingAllDictionaries: PropTypes.bool,
    // redux-form
    item: connectedDictionaryType,
    items: PropTypes.arrayOf(connectedDictionaryType),
    name: PropTypes.string,
  };

  static defaultProps = {
    item: {},
  };

  getDictionary = () => {
    const { index, item, items, allDictionaries, formValues } = this.props;

    let dictionary = {
      columns: [],
    };
    if (formValues.dictionary_connections) {
      dictionary = formValues.dictionary_connections[index];
    }
    dictionary = [...items, ...allDictionaries].find(
      ({ id }) => id === item.id || id === item.dictionary,
    ) || {
      columns: [],
    };

    return dictionary;
  };

  getDictionaries = value => {
    this.props.getAllDictionaries({
      page: PAGE,
      size: SIZE,
      name__icontains: value,
    });
  };

  handleDelete = () => {
    const { index, fields } = this.props;
    fields.remove(index);
  };

  handleOpen = () => {
    this.getDictionaries('');
  };

  handleChangeValue = value => {
    this.getDictionaries(value);
  };

  handleSelectItem = dictionary => {
    const { fields, index } = this.props;
    fields.remove(index);
    fields.push({
      ...dictionary,
      dictionary: dictionary.id,
      feature_column_map: {},
    });
    fields.move(fields.length - 1, index);
  };

  isDictionaryValid = value =>
    value && value.dictionary ? undefined : 'Dictionaries cannot be empty';

  renderDictionary = dictionary => {
    const { name, allDictionaries, isLoadingAllDictionaries } = this.props;

    return (
      <Field
        className="custom-autocomplete"
        component={AutoCompleteMenuWrapper}
        data-test="dictionary"
        isLoading={isLoadingAllDictionaries}
        item={dictionary.name || ''}
        itemDisabledReason="Archived Dictionary!"
        items={allDictionaries}
        name={name}
        placeholder="Select or search a dictionary"
        selectItem={this.handleSelectItem}
        validate={this.isDictionaryValid}
        onChangeValue={this.handleChangeValue}
        onOpen={this.handleOpen}
      />
    );
  };

  renderFeatures = dictionary => {
    const {
      name,
      currentEntity: { features },
    } = this.props;

    return (
      <div data-test="dictionary-features" styleName="features">
        {_map(features, feature => (
          <div key={feature.id} styleName="feature">
            <div
              data-test="feature-name"
              styleName={cn('feature-name', {
                'is-archived': feature.archived,
              })}
            >
              {feature.name}
            </div>

            <Field
              placeholderSelectable
              component={FormGroupSelect}
              data-test="feature-column"
              name={`${name}.feature_column_map.${feature.id}`}
              options={dictionary.columns.map(({ name, id }) => ({
                label: name,
                value: id,
              }))}
              placeholder="Select column"
            />
          </div>
        ))}
      </div>
    );
  };

  render() {
    const {
      index,
      currentEntity: { color },
    } = this.props;

    const dictionary = this.getDictionary();

    return (
      <div styleName="row">
        <div styleName="dictionary">
          <div>
            <div
              data-test="dictionary-link"
              style={{ boxShadow: `-5px 0px ${color}` }}
              styleName="label"
            >
              Dictionary Link #{index + 1}
            </div>
            <span styleName="dash">-</span>
            {this.renderDictionary(dictionary)}
          </div>
          <TrashTooltip text="Delete Linkage" onDelete={this.handleDelete} />
        </div>
        {this.renderFeatures(dictionary)}
      </div>
    );
  }
}

export default ConnectedDictionary;
